import React from "react";
import { useTranslation } from "react-i18next";
import { useAdminGetDesignQuery } from "../../../services/organization/settings";

export default function CertificateDesign() {
  const { t } = useTranslation("settings");
  const { data: organizationDesign } = useAdminGetDesignQuery();
  const org = organizationDesign?.data;
  const logoUrl = org?.organization_logo_for_certificate || org?.certificate_logo_url;
  const signUrl = org?.sign_img_url;
  const templateUrl = org?.certificate_course_template_url || "/images/Cretifacte.png";

  return (
    <div className="py-4">
      <p className="font_14 font-color-grey pb-3">
        {t("settings:certifcateDesignHint")}
      </p>
      <div className="admin-settings__certificate">
        <div
          style={{
            width: "100%",
            aspectRatio: "422 / 301",
            position: "relative",
            backgroundImage: `url(${templateUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
        >
          {/* mirrors issued certificate logo placement */}
          {logoUrl && (
            <img
              src={logoUrl}
              alt="organization logo"
              style={{
                position: "absolute",
                top: "69.77%",
                left: "41.47%",
                width: "12.3%",
                height: "10.6%",
                objectFit: "contain",
              }}
            />
          )}

          {/* mirrors issued certificate signature placement */}
          {signUrl && (
            <img
              src={signUrl}
              alt="organization signature"
              style={{
                position: "absolute",
                top: "75%",
                left: "69.7%",
                transform: "translate(-50%, -50%)",
                maxWidth: "12.3%",
                maxHeight: "10.6%",
                objectFit: "contain",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
